import { render, staticRenderFns } from "./VoteChoose.vue?vue&type=template&id=48d78a31&scoped=true&"
import script from "./VoteChoose.vue?vue&type=script&lang=js&"
export * from "./VoteChoose.vue?vue&type=script&lang=js&"
import style0 from "./VoteChoose.vue?vue&type=style&index=0&id=48d78a31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d78a31",
  null
  
)

export default component.exports